
import React from 'react';
import { Card, CardContent } from "@/components/ui/card";
import { formatDuration } from "./utils/teamSizeUtils";

interface ProjectSummaryHeaderProps {
  selectedProject: any;
  resources: any[];
}

const ProjectSummaryHeader = ({ selectedProject, resources }: ProjectSummaryHeaderProps) => {
  if (!selectedProject) return null;

  return (
    <div className="mb-3">
      <Card className="bg-secondary/50 backdrop-blur-lg border-primary rounded-lg shadow-lg shadow-purple-500/10 py-1">
        <CardContent className="pt-0 py-0 px-6">
          <div className="flex items-center gap-8 text-white">
            <div>
              <span className="text-[13px] text-gray-400">Project: </span>
              <span className="text-[12px] text-white">{selectedProject.name}</span>
            </div>
            <div>
              <span className="text-[13px] text-gray-400">Start Date: </span>
              <span className="text-[12px] text-white">
                {selectedProject.startDate ? new Date(selectedProject.startDate).toLocaleDateString() : "Not set"}
              </span>
            </div>
            <div>
              <span className="text-[13px] text-gray-400">End Date: </span>
              <span className="text-[12px] text-white">
                {selectedProject.endDate ? new Date(selectedProject.endDate).toLocaleDateString() : "Not set"}
              </span>
            </div>
            <div>
              <span className="text-[13px] text-gray-400">Duration: </span>
              <span className="text-[12px] text-white">{formatDuration(selectedProject.duration)}</span>
            </div>
            <div>
              <span className="text-[13px] text-gray-400">Tasks: </span>
              <span className="text-[12px] text-white">{selectedProject.tasks?.length || 0}</span>
            </div>
            <div>
              <span className="text-[13px] text-gray-400">Resources Available: </span>
              <span className="text-[12px] text-white">{resources.length}</span>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  );
};

export default ProjectSummaryHeader;
